import { format, isValid } from 'date-fns';

type DateToFormatType = Date | StringOrNumber;

export const STANDARD_DATE = 'MMM dd, yyyy';
export const HUMAN_DATE = 'dd MMM yyyy';
export const TIME = 'HH:mm';
export const FULL_HUMAN_DATE_TIME = `${HUMAN_DATE}, ${TIME}`;
export const SHORT_HUMAN_DATE_TIME = `d MMM, ${TIME}`;
export const SERVER_DATE = 'yyyy-MM-dd';
export const SERVER_TIME = 'HH:mm:ssXXX';
export const SERVER_DATE_TIME = `${SERVER_DATE}'T'${SERVER_TIME}`;

export const formatDate = {
  format(date: DateToFormatType, pattern: string): string {
    if (!date || date === Infinity) {
      return '';
    }

    if (date instanceof Date || typeof date === 'string' || typeof date === 'number') {
      const dateValue = new Date(date);

      if (dateValue && isValid(dateValue)) {
        return format(dateValue, pattern);
      }

      return `${date}`;
    }

    return '';
  },
  toServer(date: DateToFormatType): string {
    return this.format(date, SERVER_DATE_TIME);
  },
  toServerDate(date: DateToFormatType): string {
    return this.format(date, SERVER_DATE);
  },
  toHumanDate(date: DateToFormatType): string {
    return this.format(date, HUMAN_DATE);
  },
  toFullHumanDateTime(date: DateToFormatType): string {
    return this.format(date, FULL_HUMAN_DATE_TIME);
  },
  toShortHumanDateTime(date: DateToFormatType): string {
    return this.format(date, SHORT_HUMAN_DATE_TIME);
  },
  toTime(date: DateToFormatType): string {
    return this.format(date, TIME);
  },
};
